<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"
      :useFieldInfo="false"
    />

    <!-- 점검개요 -->
    <div class="mb-4">
      <div>
        <h5><i class="dot"></i>점검개요</h5>
      </div>
    </div>
    <div class="writeGridContainer">
      <div class="writeGridLineItem">
        <div>조치기간</div>
        <div class="flex">
          <date-selector-rang v-model="form.조치기간"/>
        </div>
      </div>
      <div class="writeGridLineItem">
        <div>조치대상 시설</div>
        <div class="flex flex-1 items-center">
          <div v-if="isPrint" class="print-textarea">{{form.조치대상시설.join(',')}}</div>
          <field-selector class="w-full" multiple v-model="form.조치대상시설" ></field-selector>
        </div>
      </div>
      <div class="writeGridLineItem">
        <div>조치담당자</div>
        <div>
          <ml-input v-model="form.조치담당자" placeholder="홍길동"/>
        </div>
      </div>
      <div class="writeGridLineItem">
        <div>조치내용</div>
        <div>
          <ml-textarea v-model="form.조치내용" rows="5" placeholder="조치내용"/>
        </div>
      </div>
    </div>


    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DateSelectorRang from "../../../../components/selector/DateSelectorRang.vue";
import FieldSelector from "../../../../components/selector/FieldSelector.vue";

export default {
  components: {
    FieldSelector,
    DateSelectorRang,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        조치기간: {},
        조치대상시설: [],
        조치담당자: "",
        조치내용: "",
      }
    };
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
</style>
